<template>
  <div>
    <section
      id="app"
      class="coffee-machine-advisor"
      v-bind:class="{
        'machine-select-page': surveyState === 'machine-select',
        'coffee-machine-advisor-form-page': surveyState === 'completed',
        'coffee-machine-advisor-fallback-form-page':
          surveyState === 'no-results',
      }"
      :data-ga="formGa"
    >
      <div class="container">
        <div
          v-bind:class="{ 
            hidden: surveyState !== 'running'
         }"
          class="row eq-height"
        >
          <div
            class="col-xs-12 reduce-width"
            v-bind:class="{
              'col-lg-12': getCurrentPage === 0,
              'col-lg-9': getCurrentPage !== 0,
            }"
          >
            <div
              class="coffee-machine-advisor-block"
              v-bind:class="{
                'first-question': getCurrentPage === 0,
                'two-answer-cols': answersOnPage >= 5,
                'two-answer-cols-static':
                  survey.currentPage.name === 'Finanzierungsart',
                'checkbox-icons':
                  survey.currentPage.name === 'Getränkevariationen',
              }"
            >
              <div class="small-headline">
                In drei Schritten zu Ihrer persönlichen Empfehlung
              </div>
              <div class="progress-bar-wrapper">
                <b-progress
                  :max="100"
                  v-bind:key="section"
                  v-for="section in displaySections()"
                  height="3rem"
                >
                  <b-progress-bar
                    :value="progressBarData[section].progress"
                    :max="100"
                    :data-page="getCurrentPage"
                  ></b-progress-bar
                  ><span class="progress-bar-text">{{ section }}</span>
                </b-progress>
              </div>

              <survey :survey="survey"></survey>
              <div
                v-if="survey.currentPage.questions[0].getType() === 'checkbox'"
                class="multiple-choice"
              >
                Mehrfachauswahl möglich
              </div>
              <div
                v-if="survey.currentPage.name === 'Postleitzahl'"
                class="multiple-choice"
              >
                Ihre 5-stellige Postleitzahl
              </div>
              <div class="button-link prev-button-wrapper">
                <button
                  @click="prevButton()"
                  v-bind:class="{
                    hidden: getCurrentPage === 0,
                  }"
                  class="prev-button"
                  ref="prev-button"
                  :data-page="survey.currentPage.name"
                  :data-test="survey.currentPage.getValue()[survey.currentPage]"
                >
                  <i class="icon icon-angle-down arrow-left"></i>
                </button>
              </div>
              <button
                @click="nextButton()"
                id="next-button"
                ref="next-button"
                v-if="getCurrentPage >= 1"
                :data-page="survey.currentPage.name"
                :data-test="survey.currentPage.getValue()[survey.currentPage]"
                v-bind:class="{
                  active: survey.currentPage.getValue()[survey.currentPage],
                  'static-active': survey.currentPage.name === 'Postleitzahl',
                  'not-required': isQuestionRequired === false,
                }"
              >
                Weiter
              </button>
              <hr
                class="show-results-headline"
                v-if="getCurrentPage >= 1"
              >
              <StepCounter 
                :currentPage="getCurrentPage"
                v-if="getCurrentPage >= 1"
              />
              <button
                class="show-results"
                v-if="getCurrentPage >= 4"
                @click="showResultsModal()"
              >
                Zwischenergebnis zeigen
              </button>
            </div>
          </div>

          <div
            v-bind:class="{
              hidden: getCurrentPage === 0,
              'reduce-width col-lg-3 visible-lg': getCurrentPage !== 0,
            }"
          >
            <div class="coffee-machine-advisor-tag-box">
              <div id="tag-box" class="hidden">
                <div
                  v-bind:key="section + section"
                  v-for="(section, sectionIndex) in displaySections()"
                  class="tag-box-wrapper"
                >
                  <div
                    class="small-headline coffee-machine-advisor-tag-box-headline"
                  >
                    {{ section }}
                  </div>
                  <div class="coffee-machine-advisor-tag-box-button-wrapper">
                    <button
                      v-bind:key="questions.name"
                      v-for="(questions, index) in displayQuestions(section)"
                      class="result-box-item"
                      v-bind:class="{
                        hidden: questions.name === 'Postleitzahl',
                      }"
                      :data-attr-type="questions.name"
                      :data-attr-index="index"
                      @click="
                        index === 0 && sectionIndex === 0
                          ? refreshSurvey()
                          : changePage(questions.name)
                      "
                    ></button>
                  </div>
                </div>
              </div>
              <SolutionCounter
                v-if="getCurrentPage >= 4"
                :machineCounter="machineCounter"
              />
              <StepCounter :currentPage="getCurrentPage" />
              <button
                class="show-results"
                v-if="getCurrentPage >= 4"
                @click="showResultsModal()"
              >
                Zwischenergebnis zeigen
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container" v-if="surveyState === 'machine-select'">
        <div class="row sticky-badge" style="position: relative">
          <div class="full-service-disturber">
            Persönliche Beratung<span class="full-service-disturber-inline">Inklusive<br />Full-Service</span>
          </div>
          <div class="full-service-disturber full-service-disturber-border"></div>

          <!--
            <div class="sticky-badge-pre-container">
            <div href="/kontakt" @click="changeSurveyState" class="sticky-badge-container">
              <div class="full-service-disturber right">
                <span class="full-service-disturber-inline">Kostenloses Beratungs&shy;gespräch vereinbaren</span>
              </div>
              <div class="full-service-disturber full-service-disturber-border"></div>
            </div>
          </div>
          -->

          <div class="machine-select">
            <MachineItems
              pageTypeGTM="resultPage"
              :surveyData="survey.data"
              :machineList="machineList"
              :financeTypeLength="financeTypeLength"
              :financeType="financeType"
              :ab_test="ab_test"
              :hidePrices="hidePrices"
              @openForm="openForm"
            />
            <div class="machine-select-prev-button-wrapper">
              <div class="button-link prev-button-wrapper machine-select-prev-button">
                <button
                  @click="prevButton('machine-select')"
                  class="prev-button"
                  ref="prev-button"
                  :data-page="survey.currentPage.name"
                  :data-test="survey.currentPage.getValue()[survey.currentPage]"
                >
                  <i class="icon icon-angle-down arrow-left"></i>
                </button>
              </div>
              <MachineLegalText />
            </div>
          </div>
        </div>
      </div>

      <div
        id="machine-select-form-row"
        class="container"
        v-bind:class="{ hidden: surveyState !== 'completed' && surveyState !== 'machine-select' }"
      >
        <div class="row eq-height">
          <div class="col-xs-12 col-md-8 reduce-width" style="margin-left: auto; margin-right: auto;">
            <div class="form-block">
              <Form
                v-show="surveyState === 'completed'"
                formId="full-form-kaffeemaschinenberater"
                buttonText="Kostenloses Angebot einholen"
                :hideMessage="true"
                :resultData="resultData"
                headline="Fordern Sie jetzt Ihr individuelles Angebot an!"
                :survey="survey"
                @prevButton="prevButton"
                :hidePrevButton="surveyState !== 'completed'"
              />
            </div>
        </div>
        <MachineItemsSingle
                v-if="surveyState !== 'machine-select'"
                pageTypeGTM="interimResult"
                :surveyData="survey.data"
                :machineList="machineList"
                :financeTypeLength="financeTypeLength"
                :financeType="financeType"
                :ab_test="ab_test"
                :hidePrices="hidePrices"
                @openForm="openForm"
                :topPercentNumber="topPercentNumber"
                :result="selectedMachine"
              />
            </div>
      </div>

      <div class="row" v-if="surveyState === 'transmitted'">
        <div v-if="surveyState === 'transmitted'" id="form-finished">
          Formular wurde erfolgreich verschickt
        </div>
      </div>

      <div
        class="container"
        v-bind:class="{ hidden: surveyState !== 'no-results' }"
      >
        <div class="row eq-height">
          <div class="col-xs-12">
            <div class="form-block">
              <div class="full-service-disturber">
                Persönliche Beratung<span class="full-service-disturber-inline"
                  >Inklusive<br />Full-Service</span
                >
              </div>
              <div
                class="full-service-disturber full-service-disturber-border"
              ></div>
              <div class="small-form-headline"></div>
              <Form
                formId="fallback-form-kaffeemaschinenberater"
                buttonText="Kostenlose Beratung anfordern"
                :resultData="resultData"
                :showInformationBlock="true"
                :survey="survey"
                headline="Fordern Sie jetzt Ihre kostenlose Beratung an!"
                @prevButton="prevButton"
              />
            </div>
          </div>
        </div>
      </div>

      <b-modal
        ref="modal-box"
        hide-footer
        hide-header
        no-close-on-esc
        no-close-on-backdrop
        centered
        size="md"
        title="Using Component Methods"
      >
        <div class="d-block text-center">
          <i
            :class="modalIcon"
            :data-random="randomModalLoadVersion"
            aria-hidden="true"
          ></i>
          <h2>{{ modalText }}</h2>
        </div>
      </b-modal>

      <b-modal
        ref="result-modal-box"
        modal-class="result-modal-box"
        size="lg"
        centered
        hide-footer
        title="Ihr Zwischenergebnis"
      >
        <div class="d-block text-center">
          <div class="machine-select">
            <MachineItems
              pageTypeGTM="interimResult"
              :surveyData="survey.data"
              :machineList="machineList"
              :financeTypeLength="financeTypeLength"
              :financeType="financeType"
              :ab_test="ab_test"
              :hidePrices="hidePrices"
              @openForm="openForm"
              @topPercentNumber="topPercentNumber"
            />
          </div>
          <MachineLegalText />
        </div>
      </b-modal>
      
      <div class="container" :class=" ((surveyState === 'completed') || (surveyState === 'machine-select')) ? 'hidden': '' ">
        <div class="row">
          <div class="col-xs-12 reduce-width"
            :class="(getCurrentPage !== 0) ? 'col-lg-9': 'col-lg-12'"
          >
            <div class="info-icons padding-top">
              <img src="/images/default/badge-35k.png">
              <img src="/images/default/badge-810.png">
            </div>
          </div>
        </div>
      </div>
    </section>
    <SuccessPage />
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue'
import * as VueShowdown from 'vue-showdown'
import tippy from 'tippy.js'
import machineList from './data/machines.json'
import surveyData from './data/survey.json'
import modalData from './data/modal.json'
import tooltipData from './data/tooltip.json'
import { filterMachines } from './modules/filter'
import { getQuestions, getSections } from './modules/claim-data'
import {
  refreshSurvey,
  onCurrentPageChanged,
  onValueChanged,
  onAfterRenderPage,
} from './modules/survey'
import {
  sendAnalyticsEvent,
  sendAnalyticsVirtualPageView,
} from './modules/analytics'
import { randomNumber } from './modules/functions'

// Components
import SolutionCounter from './components/SolutionCounter'
import StepCounter from './components/StepCounter'
import Form from './components/Form'
import MachineItems from './components/MachineItems'
import MachineItemsSingle from './components/MachineItemsSingle'
import SuccessPage from './components/SuccessPage'
import MachineLegalText from './components/MachineLegalText'

export default {
  components: {
    SolutionCounter,
    StepCounter,
    Form,
    MachineItems,
    MachineItemsSingle,
    SuccessPage,
    MachineLegalText,
  },
  data() {
    return {
      survey: new SurveyVue.Model(surveyData[0]),
      progressBarData: this.createProgressBarData(),
      showdown: new VueShowdown.showdown.Converter(),
      modalText: '',
      modalIcon: '',
      surveyState: '',
      selectedMachine: {},
      machineCounter: 0,
      isQuestionRequired: '',
      answersOnPage: '',
      selectedAnswers: 0,
      resultData: '',
      formGa: 'getOffer',
      topPercentNumber: 0,
      financeTypeLength: 0,
      financeType: '',
      ab_test: false,
      hidePrices: false,
      randomModalLoadVersion: 0,
      machineList: machineList,
      preSelectedFirstAnswerFlag: false,
    }
  },
  created: function () {
    this.triggerOnValueChanged()
    this.onCurrentPageChanged()
    this.onAfterRenderPage()
    this.createMarkdownFromSurvey()
    this.surveyState = this.survey.state
  },
  methods: {
    showDefaultModal(modalText, modalIcon) {
      this.modalText = modalText
      this.modalIcon = modalIcon
      this.randomModalLoadVersion = randomNumber(1, 15)
      const current = filterMachines(this.survey.data, machineList)
      this.$refs['modal-box'].show()
      if (current.length === 0) {
        this.showNoResultsModal()
      } else {
        this.$refs['modal-box'].show()
      }
    },
    showPostalcodeModal() {
      this.modalText = modalData['pruefeServiceOption'].text
      this.modalIcon = modalData['pruefeServiceOption'].icon
      this.randomModalLoadVersion = randomNumber(1, 15)
      this.$refs['modal-box'].show()
      setTimeout(() => {
        this.randomModalLoadVersion = 0
        this.modalText = modalData['alleServiceOptionenVerfuegbar'].text
        this.modalIcon = modalData['alleServiceOptionenVerfuegbar'].icon
        setTimeout(() => {
          this.$refs['modal-box'].hide()
          this.survey.nextPage()
        }, 2000)
      }, 2200)
    },
    showNoResultsModal() {
      this.modalText = modalData['ermittleZwischenergebnis'].text
      this.modalIcon = modalData['ermittleZwischenergebnis'].icon
      this.randomModalLoadVersion = randomNumber(1, 15)
      this.$refs['modal-box'].show()
      let data = this.survey.data
      Object.keys(data).forEach(function (key) {
        if (typeof data[key] === 'object') {
          data[key] = data[key].join(', ')
        }
      })
      this.resultData = data
      this.resultData = JSON.stringify(this.resultData)
      setTimeout(() => {
        this.$refs['modal-box'].hide()
        this.formGa = 'getConsulting'
        this.surveyState = 'no-results'
        document.getElementById('app').scrollIntoView()
        sendAnalyticsVirtualPageView('formular-beratung', 'Formular Beratung')
      }, 2000)
    },
    backToAdvisor() {
      this.formGa = 'getOffer'
      this.surveyState = 'running'
      document.getElementById('app').scrollIntoView()
      this.survey.currentPageNo = 1
      sendAnalyticsEvent('getConsulting', 'click', 'Einstellungen anpassen')
    },
    showResultsModal() {
      const current = filterMachines(this.survey.data, machineList)
      if (current.length === 0) {
        this.showNoResultsModal()
      } else {
        if (this.survey.data['Finanzierungsart']) {
          this.financeTypeLength = this.survey.data['Finanzierungsart'].length
          this.financeType = this.survey.data['Finanzierungsart']
        }

        this.checkABtestState();
        this.hidePricesSetting();

        sendAnalyticsEvent(
          this.survey.currentPageValue.name,
          'clickResults',
          'Zwischenergebnis anzeigen'
        )
        this.$refs['result-modal-box'].show()
      }
    },
    hideDefaultModal() {
      setTimeout(() => {
        this.randomModalLoadVersion = 0
        this.$refs['modal-box'].hide()
        if (this.survey.isLastPage === true) {
          const current = filterMachines(this.survey.data, machineList)
          if (current.length === 0) {
            this.formGa = 'getConsulting'
            this.surveyState = 'no-results'
            sendAnalyticsVirtualPageView(
              'formular-beratung',
              'Formular Beratung'
            )
            document.getElementById('app').scrollIntoView()
          } else {
            sendAnalyticsVirtualPageView(
              'maschinen-auswahl',
              'Maschinen Auswahl'
            )
            this.surveyState = 'machine-select'
            document.getElementById('app').scrollIntoView()
          }
        } else {
          this.survey.nextPage()
        }
      }, 2200)
    },
    createProgressBarData() {
      let progressBarData = []
      this.displaySections().forEach((section) => {
        progressBarData[section] = []
      })
      return progressBarData
    },
    openForm(machine, pageType, topPercentNumber) {
      if (topPercentNumber) {
        this.topPercentNumber = topPercentNumber
      }
      sendAnalyticsEvent(pageType, 'getFreeOffer', machine.maschinenbezeichnung)
      sendAnalyticsVirtualPageView('formular-angebot', 'Formular Angebot')
      this.selectedMachine = machine
      this.$refs['result-modal-box'].hide()
      this.survey.doComplete()
      this.surveyState = this.survey.state
      let data = this.survey.data
      Object.keys(data).forEach(function (key) {
        if (typeof data[key] === 'object') {
          data[key] = data[key].join(', ')
        }
      })
      this.resultData = data
      this.resultData['Maschine'] = machine.maschinenbezeichnung
      this.resultData = JSON.stringify(this.resultData)
      document.getElementById('app').scrollIntoView()
      
      this.checkABtestState();
      this.hidePricesSetting();
    },
    sendForm() {
      this.surveyState = 'transmitted'
      document.getElementById('form-success').scrollIntoView()
    },
    refreshSurvey() {
      this.$bvModal
        .msgBoxConfirm(
          'Wenn Sie diese Auswahl anpassen, werden auch alle weiteren Daten zurückgesetzt.',
          {
            title: 'Es ergeben sich Auswirkungen auf Ihre getroffene Auswahl.',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Forfahren',
            cancelTitle: 'Abbrechen',
            contentClass: 'cancel-block',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            sendAnalyticsEvent(
              this.survey.currentPageValue.name,
              'clickModalbox - question 1',
              'Fortfahren'
            )
            refreshSurvey(this.survey)
          } else {
            sendAnalyticsEvent(
              this.survey.currentPageValue.name,
              'clickModalbox - question 1',
              'Abbrechen'
            )
          }
        })
    },
    displaySections() {
      return getSections(surveyData)
    },
    displayQuestions(section) {
      return getQuestions(section, surveyData)
    },
    changePage(data) {
      sendAnalyticsEvent(this.survey.currentPageValue.name, 'clickTagbox', data)
      this.survey.currentPage = this.survey.getPageByName(data)
    },
    triggerOnValueChanged() {
      onValueChanged(this, filterMachines, machineList, modalData)
    },
    onCurrentPageChanged() {
      onCurrentPageChanged(
        this,
        this.displayQuestions(),
        this.displaySections(),
        surveyData
      )
    },
    prevButton(type = '') {
      let questionName = this.survey.currentPageValue.name
      let questionValue = this.survey.currentPageValue.questions[0].value
      document.getElementById('app').scrollIntoView()
      if (type === 'form') {
        type = document.getElementById('app').dataset['ga']
      }
      switch (type) {
        case 'getOffer':     
          this.checkABtestState();
          this.hidePricesSetting();

          this.surveyState = 'machine-select'
          sendAnalyticsEvent('form', 'clickZurück', type)        
          break
        case 'getConsulting':
          this.surveyState = 'running'
          sendAnalyticsEvent('form', 'clickZurück', type)
          break
        case 'machine-select':
          this.checkABtestState();
          this.hidePricesSetting();

          this.surveyState = 'running'
          sendAnalyticsEvent('machine-select', 'clickZurück')
          break
        default:
          this.surveyState = 'running'
          sendAnalyticsEvent(questionName, 'clickZurück', questionValue)
            if (this.survey.currentPageNo === 1) {
              this.refreshSurvey()
            } else {
              this.survey.prevPage()
            }
          break
      }
    },
    nextButton() {
      this.checkABtestState();
      this.hidePricesSetting();

      let questionName = this.survey.currentPageValue.name
      let questionValue = this.survey.currentPageValue.questions[0].value
      if (this.survey.isCurrentPageHasErrors === true) {
        sendAnalyticsEvent(
          questionName,
          'error',
          this.survey.currentPageValue.questions[0].errors[0].text
        )
      }
      if (typeof questionValue === 'object') {
        questionValue.forEach(function (value) {
          sendAnalyticsEvent(questionName, 'clickWeiter', value)
        })
        if (questionValue.length === 0) {
          document
            .querySelectorAll(
              ".result-box-item[data-attr-type='" + questionName + "']"
            )[0]
            .classList.add('hidden')
        }
      } else {
        if (questionName === 'Postleitzahl') {
          if (this.survey.isCurrentPageHasErrors === false) {
            questionValue = 'valid'
          } else {
            questionValue = 'not_valid'
          }
        }
        sendAnalyticsEvent(questionName, 'clickWeiter', questionValue)
      }

      if (
        this.$refs['next-button'].dataset.page === 'Postleitzahl' &&
        this.survey.isCurrentPageHasErrors === false
      ) {
        this.showPostalcodeModal()
      } else if (modalData.trigger[this.survey.currentPageNo]) {
        this.showDefaultModal(
          modalData[modalData.trigger[this.survey.currentPageNo]].text,
          modalData[modalData.trigger[this.survey.currentPageNo]].icon
        )
        this.hideDefaultModal()
      } else {
        this.survey.nextPage()
      }
    },
    onAfterRenderPage() {
      onAfterRenderPage(this, tooltipData, tippy)
    },
    createMarkdownFromSurvey() {
      this.survey.onTextMarkdown.add((survey, options) => {
        //convert the mardown text to html
        var str = this.showdown.makeHtml(options.text)
        str = str.substring(3)
        str = str.substring(0, str.length - 4)
        options.html = str
      })
    },
    preSelectedFirstAnswer() {
      const urlParams = this.getUrlParams(window.location.search)
      if (urlParams.branche && this.preSelectedFirstAnswerFlag === false) {
        let answer = document.querySelectorAll(
          '[data-preselected-answer=' + urlParams.branche + ']'
        )[0].innerText
        this.survey.currentPage.questions[0].value = answer
        this.preSelectedFirstAnswerFlag = true
      }
    },
    getUrlParams(search) {
      const hashes = search.slice(search.indexOf('?') + 1).split('&')
      const params = {}
      hashes.map((hash) => {
        const [key, val] = hash.split('=')
        params[key] = decodeURIComponent(val)
      })
      return params
    },
    changeSurveyState() {
      this.surveyState = "no-results"
    },
    checkABtestState(){
      if(window.ab_test_go){
        this.ab_test = true;
      }
    },
    hidePricesSetting(){
      this.hidePrices = true
    }
  },
  computed: {
    countQuestionsPerSection(section) {
      return surveyData[0]['pages'].filter((page) => page.section === section)
        .length
    },
    countPages() {
      return this.survey.pageCount
    },
    getCurrentPage() {
      return this.survey.currentPageNo
    },
  },
}
</script>
